import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Images } from "config/images";

const useStyles = makeStyles(
	theme =>
		createStyles({
			rootHeader: {
				height: 127,
				background: theme.palette.primary.main,
				borderRadius: "0px 0px 12px 12px",
				marginBottom: 30
			},
			header: {
				display: "flex",
				padding: 19,
				justifyContent: "center",
				alignItems: "center"
			},
			btnBack: {
				marginRight: 10,
				cursor: "pointer",
				position: "absolute",
				left: 16,
				"&:active": {
					opacity: 0.7
				}
			},
			title: {
				color: theme.palette.primary.contrastText,
				fontSize: 18,
				fontWeight: 600
			},
			rootPoint: {
				background: theme.palette.common.white,
				height: 90,
				boxShadow: "0px 3px 29px rgb(114 136 128 / 15%)",
				borderRadius: 10
			},
			bgPoint: {
				backgroundImage: `url(${Images.bgPoint})`,
				backgroundRepeat: "no-repeat",
				backgroundSize: "100% 90px",
				width: "100%",
				height: 90,
				borderRadius: 10
			},
			point: {
				padding: "20px 15px",
				height: 50,
				display: "flex",
				flexDirection: "column",
				justifyContent: "space-between"
			},
			titlePoint: {
				color: theme.palette.grey[50],
				fontSize: 14
			},
			price: {
				display: "flex",
				alignItems: "center",
				color: theme.palette.primary.contrastText,
				fontSize: 18,
				fontWeight: 600,
				"& > img": {
					width: 18,
					height: 18,
					marginRight: 5
				}
			},
			gift: {
				height: `calc(100vh - 157px)`,
				overflowX: "hidden",
				overflowY: "scroll"
			}
		}),
	{
		name: "HeaderPage",
		index: 1
	}
);

export default useStyles;
